import React from 'react'
import { EmptyState } from '@components/ui'
import type { ErrorFallbackProps } from './ErrorBoundary.types'
import './ErrorBoundary.css'

const PAGE_TITLE = 'Something went wrong'
const PAGE_DESCRIPTION =
  'Something went wrong while showing this screen. Try again, or pick another page from the sidebar.'
const PAGE_ACTION_LABEL = 'Try again'

const ROOT_TITLE = 'An unexpected error occurred'
const ROOT_DESCRIPTION =
  'The application hit an unexpected error. Reload the page to continue.'
const ROOT_ACTION_LABEL = 'Reload page'

function ErrorFallback({
  variant,
  onReset,
}: ErrorFallbackProps): React.ReactElement {
  const isRoot = variant === 'root'

  const handleAction = (): void => {
    if (isRoot) {
      window.location.reload()
      return
    }
    onReset()
  }

  return (
    <div
      className={`app-error-boundary-fallback app-error-boundary-fallback--${variant}`}
      role="alert"
    >
      <EmptyState
        outlined
        title={isRoot ? ROOT_TITLE : PAGE_TITLE}
        description={isRoot ? ROOT_DESCRIPTION : PAGE_DESCRIPTION}
        actionLabel={isRoot ? ROOT_ACTION_LABEL : PAGE_ACTION_LABEL}
        onAction={handleAction}
        iconClass="mgc_warning_line"
      />
    </div>
  )
}

export default ErrorFallback
